export const Brands = () => {
  return (
    <div className="flex items-center justify-center">
      <img src="logos.png" alt="" />
    </div>
  );
};
